import { render } from "./PosTimePanel.vue?vue&type=template&id=12980306&scoped=true"
import script from "./PosTimePanel.vue?vue&type=script&lang=js"
export * from "./PosTimePanel.vue?vue&type=script&lang=js"

import "./PosTimePanel.vue?vue&type=style&index=0&id=12980306&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12980306"]])

export default __exports__